import { Typography } from "antd";
import { AxiosError } from "axios";

const ErrorViewer = ({ title, error }: { title?: string; error?: AxiosError | string }) => {
  const isString = typeof error === "string";

  return (
    <div className="error-viewer">
      {title && <Typography.Title level={2}>{title}</Typography.Title>}
      {error && isString && <Typography.Text type="danger">Error: {error}</Typography.Text>}
      {error && !isString && (
        <>
          <Typography.Text type="danger" copyable>
            Error: {error.message}
          </Typography.Text>
          <Typography.Text type="danger" copyable>
            Status: {error.response?.status}
          </Typography.Text>
          <Typography.Text type={"danger"} copyable ellipsis={true}>
            {JSON.stringify(error.response?.data, null, 2)}
          </Typography.Text>
        </>
      )}
    </div>
  );
};
export default ErrorViewer;
